
import React from 'react';
import ZProps from './zprops';
import { APP } from './App';
import { ROUTER } from './AMCRouter';
import ZLog from "./zlog";
import ZUtil from './zutil';
import ZNetwork from './znetwork';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from "yup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'



function AMCAuth() {
	this.signIn = () => {
		APP.showPopup( <AutomaticSigninPopup /> );
	}
	this.signOut = ()  => {
//		ZProps.set(AMCConstants.SIGNED_IN, false);
		ZNetwork.post("out", function(err, payload) {
			//ZProps.set('user', payload.user);
			//ZProps.set('usersettings', payload.usersettings);
			ZUtil.setCandy("username", payload.user.uri);
			window.location.href = "/";
		});
	}
	this.signUp = () => {
		APP.showPopup( <AutomaticJoinPopup /> );
	}
	this.signedIn = (user, settings, group) => {
		if (user) {
			ZUtil.setCandy("username", user.uri);
			ZProps.set('user', user);
			ZProps.set('usersettings', settings);
			ZProps.set('usergroup', group);
			ZProps.set('beta', false);
//			if (!user.guest) {
//				ZProps.set(AMCConstants.SIGNED_IN, true);
//			}
			if (ROUTER && window.location.href.endsWith("/signin")) {
				ROUTER.pushRoute("/zoo");
			} else {
				APP.forceUpdate();
			}
		}
	}
	this.forgotPassword = () => {
		APP.showPopup( <AutomaticForgotPaswordPopup /> );
	}
	this.register = () => {
		this.signUp();
	}
}
export var AUTH = new AMCAuth();


export class AutomaticJoinPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		return (
			<div className="StandardPopup CENTERED" onClick={ZUtil.eatEvent}>
				<AutomaticJoiningForm />
			</div>
		)
	}
}
export class AutomaticJoiningForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { submit_button_label, hide_banner } = this.props;
		return (
			<div className="StandardForm">
				{ hide_banner ? "" : <div className="StandardFormHeader">Let's do this</div> }
				<Formik
					initialValues={{ username: '', email: '', password: ''}} // , agreeToTerms: false 
					validationSchema={Yup.object().shape({
						username: Yup.string()
							.min(3, 'Too Short!')
							.max(20, 'Too Long!')
							.required('Username is required')
							.matches( /^[a-zA-Z0-9\-_]+$/, 'Only A-z, 0-9, -, and _ in usernames')
							.notOneOf(['likes','rockstar','zoo'], 'Username is taken'),
						email: Yup.string()
							.email('Invalid email')
							.max(100, 'Too Long!')
							.required('Email is required'),
						password: Yup.string()
							.min(6, 'Password must be at least 6 characters')
							.max(20, 'Too Long!')
							.required('Password is required'),
						agreeToTerms: Yup.boolean()
							.oneOf([true], 'Must Accept Terms and Conditions')
					})}
					onSubmit={(values, actions) => {
						actions.setSubmitting(false);
						ZNetwork.post("up", {username: values.username, email: values.email, password: values.password }, (err, userplus) => {
							if (!err) {
								APP.setBanner("Welcome, " + userplus.user.uri);
								AUTH.signedIn(userplus.user, userplus.settings, userplus.group);
								APP.closePopups();
								ROUTER.pushRoute("/zoo");
							} else {
								ZLog.log("error: " + ZUtil.inspect(err));
								actions.setErrors({status: err});
								// username taken
								APP.clearError();
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => ( //, values, setFieldValue }) => (
					<Form>
						<StandardFormRow> 
							<Field name="email" type="email" placeholder="Your email" className={"StandardFormField" + (errors.email && touched.email ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="email" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow>
						<StandardFormRow> 
							<Field name="password" type="password" placeholder="Password" className={"StandardFormField"  + (errors.password && touched.password ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="password" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						<StandardFormRow> 
							<Field name="username" placeholder="Username" className={"StandardFormField" + (errors.username && touched.username ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="username" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						
						<StandardFormRow> 
							<div className="StandardFormRowCheckboxContainer">
							<Field type="checkbox" name="agreeToTerms" id="agreeToTerms" className={"StandardFormField"  + (errors.agreeToTerms && touched.agreeToTerms ? " StandardFormFieldCheckboxError" : "")} />
							<label htmlFor="agreeToTerms">I agree to <a href="/-/terms" target="_blank">Terms</a> and <a href="/-/privacy" target="_blank">Privacy Policy</a></label>
							</div>
							<ErrorMessage name="agreeToTerms" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: '' }
						<div className="StandardFormFooter">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => ZUtil.noop(e)}>{submit_button_label || "Create free account"}</button>
						</div>
					</Form>
					)}
				/>
			</div>
		);
	}
}
export class BetaLoginForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { submit_button_label, hide_banner, class_name } = this.props;
		return (
			<div className={"StandardForm" + (class_name ? " " + class_name : "")}>
				{ hide_banner ? "" : <div className="StandardFormHeader">Let's do this</div> }
				<Formik
					initialValues={{ password: ''}} 
					validationSchema={Yup.object().shape({
						password: Yup.string()
							.min(6, 'Password must be at least 6 characters')
							.max(20, 'Too Long!')
							.required('Password is required'),
					})}
					onSubmit={(values, actions) => {
						ZNetwork.post("in", {username_or_email: values.username_or_email, password: values.password }, (err, userplus) => {
							actions.setSubmitting(false);
							if (!err && userplus.command && userplus.command === "beta") {
								APP.closePopups();
								ZUtil.setCandy("beta", "" + Date.now());
								window.location.href = "/zoo";
							} else {
								ZLog.log("error: " + ZUtil.inspect(err));
								actions.setErrors({status: "Something's not right. Please try again."});
								APP.clearError();
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => ( //, values, setFieldValue }) => (
					<Form>
						<StandardFormRow> 
							<Field name="password" type="password" placeholder="Password" className={"StandardFormField"  + (errors.password && touched.password ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="password" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: '' }
						<div className="StandardFormFooter">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => ZUtil.noop(e)}>{submit_button_label || "Create free account"}</button>
						</div>
					</Form>
					)}
				/>
			</div>
		);
	}
}
export class AutomaticJoiningFormMini extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let closed_at = parseInt(ZUtil.getCandy("joinformmini") || "0", 10);
		if (Date.now() - closed_at < 24*60*60*1000) {
			this.setState({ closed: true });
		}
	}
	onClose = (e) => {
		e.preventDefault();
		e.stopPropagation();
		ZUtil.setCandy("joinformmini", Date.now());
		this.setState({ closed: true });
	}
	render() {
		let { closed } = this.state;
		if (closed) {
			return null;
		}
		return (
			<div className="StandardFormMini">
				<div className="AutomaticJoiningFormMiniArrow"></div>
				<div className="AutomaticJoiningFormMiniArrowBorder"></div>
				<div className="AutomaticJoiningFormMiniCloseButton" onClick={this.onClose}><FontAwesomeIcon icon={faTimes} /></div>
				<Formik
					initialValues={{ username: '', email: '', password: ''}} // , agreeToTerms: false 
					validationSchema={Yup.object().shape({
						username: Yup.string()
							.min(3, 'Too Short!')
							.max(20, 'Too Long!')
							.required('Username is required')
							.matches( /^[a-zA-Z0-9\-_]+$/, 'Only A-z, 0-9, -, and _ in usernames')
							.notOneOf(['likes','rockstar','zoo'], 'Username is taken'),
						email: Yup.string()
							.email('Invalid email')
							.max(100, 'Too Long!')
							.required('Email is required'),
						password: Yup.string()
							.min(6, 'Password must be at least 6 characters')
							.max(20, 'Too Long!')
							.required('Password is required'),
						agreeToTerms: Yup.boolean()
							.oneOf([true], 'Must Accept Terms and Conditions')
					})}
					onSubmit={(values, actions) => {
						actions.setSubmitting(false);
						ZNetwork.post("up", {username: values.username, email: values.email, password: values.password }, (err, userplus) => {
							if (!err) {
								APP.setBanner("Welcome, " + userplus.user.uri);
								AUTH.signedIn(userplus.user, userplus.settings, userplus.group);
								APP.closePopups();
								window.location.href = "/zoo";
							} else {
								actions.setErrors({status: err});
								// username taken
								APP.clearError();
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => ( //, values, setFieldValue }) => (
					<Form>
						<StandardFormRow> 
							<Field name="email" type="email" placeholder="Email" className={"StandardFormField" + (errors.email && touched.email ? " StandardFormFieldError" : "")} />
						</StandardFormRow>
						<StandardFormRow> 
							<Field name="password" type="password" placeholder="Password" className={"StandardFormField"  + (errors.password && touched.password ? " StandardFormFieldError" : "")} />
						</StandardFormRow> 
						<StandardFormRow> 
							<Field name="username" placeholder="Username" className={"StandardFormField" + (errors.username && touched.username ? " StandardFormFieldError" : "")} />
						</StandardFormRow> 
						<div className="StandardFormRowCheckboxContainer">
							<Field type="checkbox" name="agreeToTerms" id="agreeToTerms" className={"StandardFormField"  + (errors.agreeToTerms && touched.agreeToTerms ? " StandardFormFieldCheckboxError" : "")} />
							<label htmlFor="agreeToTerms">I agree to <a href="/-/terms" target="_blank">Terms</a> and <a href="/-/privacy" target="_blank">Privacy Policy</a></label>
						</div> 
						<div className="StandardFormRow">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => ZUtil.noop(e)}>Create free account</button>
							<span className="AutomaticJoiningFormMiniSignInButtonOr">or</span>
							<a className="AutomaticJoiningFormMiniSignInButton" onClick={() => AUTH.signIn()}>sign in</a>
						</div>
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: '' }
						<ErrorMessage name="email" component="div" className="StandardFormFieldErrorMsg" />
						<ErrorMessage name="username" component="div" className="StandardFormFieldErrorMsg" />
						<ErrorMessage name="password" component="div" className="StandardFormFieldErrorMsg" />
						<ErrorMessage name="agreeToTerms" component="div" className="StandardFormFieldErrorMsg" />
					</Form>
					)}
				/>
			</div>
		);
	}
}
export class AutomaticSigninPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { submit_button_label, banner_label, hide_footers, contact_footers, class_name } = this.props;
		return (
			<div className={"StandardPopup CENTERED" + (class_name ? " " + class_name : "")} onClick={ZUtil.eatEvent}>
			<div className="StandardForm">
				<div className="StandardFormHeader">{banner_label || "Let's sign you in"}</div>
				<Formik
					initialValues={{ username_or_email: '', password: '' }}
					validationSchema={Yup.object().shape({
						username_or_email: Yup.string()
							.required('Username is required')
							.min(3, 'Username must be at least 3 characters')
							.max(100, 'Too Long!'),
						password: Yup.string()
							.min(6, 'Password must be at least 6 characters')
							.max(20, 'Too Long!')
							.required('Password is required'),
					})}
					onSubmit={(values, actions) => {
						ZNetwork.post("in", {username_or_email: values.username_or_email, password: values.password }, (err, userplus) => {
							actions.setSubmitting(false);
							if (!err && userplus.user) {
								APP.setBanner("Welcome, " + userplus.user.uri);
								AUTH.signedIn(userplus.user, userplus.settings, userplus.group);
								APP.closePopups();
								// TESTT window.location.href = "/";
							} else if (!err && userplus.command && userplus.command === "beta") {
								APP.closePopups();
								ZUtil.setCandy("beta", "" + Date.now());
								// TESTT window.location.href = "/";
							} else {
								actions.setErrors({status: "Something's not right. Please try again."});
								APP.clearError();
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => (
					<Form>
						<StandardFormRow> 
							<Field name="username_or_email" placeholder="Email or username" className={"StandardFormField" + (errors.username_or_email && touched.username_or_email ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="username_or_email" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow>
						<StandardFormRow> 
							<Field name="password" type="password" placeholder="Password" className={"StandardFormField"  + (errors.password && touched.password ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="password" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: '' }
						<div className="StandardFormFooter">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => handleSubmit(e)}>{submit_button_label || "Sign in"}</button>
						</div>
						{ hide_footers ? '' :
						<div className="StandardFormFooterDetail">
							<a className="StandardFormFooterDetailLeft" onClick={() => AUTH.forgotPassword()}>forgot password?</a>
							<a className="StandardFormFooterDetailRight" onClick={() => AUTH.register()}>register</a>
						</div>
						}
						{ contact_footers ? 
						<div className="StandardFormFooterDetail">
						      <a className="StandardFormFooterDetailLeft" href="mailto:contact@automatic.ai">Want to beta? contact@automatic.ai</a>
						</div>
						: '' }
					</Form>
					)}
				/>
			</div>
			</div>
		);
	}
}
export class AutomaticForgotPaswordPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		return (
			<div className="StandardPopup" onClick={ZUtil.eatEvent}>
			<div className="StandardForm">
				<div className="StandardFormHeader">Let's get you another password</div>
				<Formik
					initialValues={{ username_or_email: '', password: '' }}
					validationSchema={Yup.object().shape({
						email: Yup.string().email()
							.required('Required')
							.min(6, 'Username must be at least 6 characters')
							.max(48, 'Too Long!'),
					})}
					onSubmit={(values, actions) => {
						ZNetwork.post("forgot", {email: values.email }, (err) => {
							actions.setSubmitting(false);
							if (!err) {
								actions.setStatus({status: "Email sent. Please click link in email to reset password."});
							} else {
								actions.setErrors({status: "Sorry, that didn't work. Please try again."});
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => (
					<Form>
						<StandardFormRow> 
							<Field name="email" placeholder="Email" className={"StandardFormField" + (errors.email && touched.email ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="email" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow>
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: status ?
							<StandardFormRow> 
								<div className="StandardFormOKStatus">{status.status}</div>
							</StandardFormRow> 
						: 
						<div className="StandardFormFooter">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => handleSubmit(e)}>Reset password</button>
						</div>
						}
					</Form>
					)}
				/>
			</div>
			</div>
		);
	}
}
export class AutomaticAddOrganizationPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		return (
			<div className="StandardPopup CENTERED" onClick={ZUtil.eatEvent}>
				<AutomaticAddOrganizationForm />
			</div>
		)
	}
}
class AutomaticAddOrganizationForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { submit_button_label, hide_banner } = this.props;
		return (
			<div className="StandardForm">
				{ hide_banner ? "" : <div className="StandardFormHeader">Create Organization</div> }
				<Formik
					initialValues={{ username: '', email: '', password: ''}} // , agreeToTerms: false 
					validationSchema={Yup.object().shape({
						orgname: Yup.string()
							.min(3, 'Too Short!')
							.max(20, 'Too Long!')
							.required('Org name is required')
							.matches( /^[a-zA-Z0-9\-_]+$/, 'Only A-z, 0-9, -, and _ in usernames')
							.notOneOf(['likes','rockstar','zoo'], 'Org name is taken'),
						password: Yup.string()
							.min(6, 'Password must be at least 6 characters')
							.max(20, 'Too Long!')
							.required('Password is required'),
						agreeToTerms: Yup.boolean()
							.oneOf([true], 'Must Accept Terms and Conditions')
					})}
					onSubmit={(values, actions) => {
						actions.setSubmitting(false);
						ZNetwork.post("organization", { orgname: values.orgname, email: values.email, password: values.password }, (err, userplus) => {

							if (!err) {
								APP.setBanner("Welcome, " + userplus.user.uri);
								AUTH.signedIn(userplus.user, ZProps.get("usersettings"), userplus.org);
								APP.closePopups();
								ROUTER.pushRoute("/organizations/" + userplus.org.uri);
							} else {
								actions.setErrors({status: err});
								// username taken
								APP.clearError();
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => ( //, values, setFieldValue }) => (
					<Form>
						<StandardFormRow> 
							<Field name="orgname" placeholder="Organization name" className={"StandardFormField" + (errors.orgname && touched.orgname ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="orgname" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						<StandardFormRow> 
							<Field name="password" type="password" placeholder="Password" className={"StandardFormField"  + (errors.password && touched.password ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="password" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: '' }
						<div className="StandardFormFooter">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => ZUtil.noop(e)}>{submit_button_label || "Create organization"}</button>
						</div>
					</Form>
					)}
				/>
			</div>
		);
	}
}
export class AutomaticOrganizationSigninPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { org_uri, submit_button_label, class_name, hide_footers } = this.props;
		return (
			<div className={"StandardPopup CENTERED" + (class_name ? " " + class_name : "")} onClick={ZUtil.eatEvent}>
			<div className="StandardForm">
				<div className="StandardFormHeader">{"Let's sign you in to " + org_uri}</div>
				<Formik
					initialValues={{ password: '' }}
					validationSchema={Yup.object().shape({
						password: Yup.string()
							.min(6, 'Password must be at least 6 characters')
							.max(20, 'Too Long!')
							.required('Password is required'),
					})}
					onSubmit={(values, actions) => {
						ZNetwork.post("organization", "switch", {org_uri: org_uri, password: values.password }, (err, userplus) => {
							actions.setSubmitting(false);
							if (!err && userplus.user) {
								APP.setBanner("Welcome, " + userplus.user.uri);
								AUTH.signedIn(userplus.user, userplus.settings, userplus.group);
								APP.closePopups();
								window.location.href = "/organizations/" + org_uri;
							} else {
								actions.setErrors({status: "Something's not right. Please try again."});
								APP.clearError();
							}
						});
					}}
					render={({ errors, status, touched, isSubmitting, handleSubmit }) => (
					<Form>
						<StandardFormRow> 
							<Field name="password" type="password" placeholder="Password" className={"StandardFormField"  + (errors.password && touched.password ? " StandardFormFieldError" : "")} />
							<ErrorMessage name="password" component="div" className="StandardFormFieldErrorMsg" />
						</StandardFormRow> 
						{ errors.status ?
							<StandardFormRow> 
								<div className="StandardFormErrorStatus">{errors.status}</div>
							</StandardFormRow> 
						: '' }
						<div className="StandardFormFooter">
							<button type="submit" className="StandardFormSubmitButton BUTTON_BACKGROUND_COLOR" disabled={isSubmitting} onClick={(e) => handleSubmit(e)}>{submit_button_label || "Sign in"}</button>
						</div>
						{ hide_footers ? '' :
						<div className="StandardFormFooterDetail">
							<a className="StandardFormFooterDetailLeft" onClick={() => AUTH.forgotPassword()}>forgot password?</a>
						</div>
						}
					</Form>
					)}
				/>
			</div>
			</div>
		);
	}
}
function StandardFormRow(props) {
	return <div className="StandardFormRow">{props.children}</div>
}



// WEBPACK FOOTER //
// ./src/AMCAuth.js